<template>
  <div class="grid-content bg-purple ">

    <h2 style="float: left;">运维资料列表</h2>
    <div class="lu_head">
    	<!--<el-tag
      v-for="item in items"
      :key="item.id"
      :type="item.type"
      @click="selectScoreFile(item.id,1)"
      :class="{active : item.id===curId}"
      effect="light">
      {{ item.label }}
    </el-tag>-->
			<span v-for="item in items" class="lu_list" :class="{lu_active : item.operatorNum===curId}" @click="selectScoreFile(item.operatorNum,1)">
    		<img :src="item.logo"/>{{ item.operatorName }}</span>
    <div class="point" style="float: left;">

    <el-col :span="4" style="padding: 0; margin:10px 20px ;width:auto; ">
      <el-date-picker
        v-model="ayears"
        type="year"
        format="yyyy"
        value-format="yyyy"
        @change="pickerChangeFn"
        placeholder="请选择年份">
      </el-date-picker>
    </el-col>
    <el-col :span="4" style="padding: 0;margin:10px 0px ; margin-right: 20px;width:auto; ">

      <!--                  <h2 style="float: left;">第</h2>-->

      <!--                  <el-input v-model="aquarter" type="text" placeholder="请输入季度"></el-input>-->
      <el-select v-model="aquarter" placeholder="请选择季度" style=" ;padding: 0px 0px 0px;width: 120px" :clearable ="true">

        <el-option
          v-for="item in quarters"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <!-- <h2 style="float: left;">季度</h2>&ndash;&gt;-->
    </el-col>
    <el-col :span="4 " style="padding: 0; margin-right: 10px; width:auto; ">
      <el-button type="info" style="width: 139px; height: auto; color: #fff ; text-align: center; margin-top:0px!important" @click="setabt()">查询</el-button>
    </el-col>
    </div>
    
    </div>
    
    <div class="table-box">
    <el-table
      :data="selectScoreFilelist"
      height="550"
      border
      style="width: 100%;">
      <el-table-column
        label="指标类别"
        prop="scoreTypeName"
        width="300"
      >

      </el-table-column>
      <el-table-column

        label="指标项"
        width="300">
        <template slot-scope="scope">
          {{scope.row.scoreItemName}}
        </template>
      </el-table-column>
      <el-table-column

        label="考核资料">

        <template slot-scope="scope">
          <div v-for="items in scope.row.fileJson" :key="items.id">
          <el-link  type="primary" :href="items.url" target="_blank">{{items.fileName}}</el-link>
            <br/>
          </div>
        </template>
      </el-table-column>



    </el-table>
    <el-pagination
    	v-if="selectScoreFiletotal>10"
      background
      layout="prev, pager, next"
      :page-size="selectScoreFilepageSize"
      @current-change="setselectScoreFile"
      :total="selectScoreFiletotal"
      :current-page="currentPage"
      >

    </el-pagination>
  </div> </div>
</template>

<script>
export default {
  name: "Scorefile",
  data(){
    return {
      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],
      items: [
//      {   id:1,
//        type: 'success',
//        code:'MT'
//      },
//      {   id:2,
//        type: 'info',
//        code:'HB'
//      },
//      {
//        id:3,
//        type: 'danger',
//        code:'DD'
//      },
      ],
      curId:1,
			currentPage:1,
      selectScoreFilepage:1,
      selectScoreFiletotal:0,
      selectScoreFilelist:[],
      selectScoreFilepageSize:10,
      aquarter:'',
      ayears:'',
      aquarte:'',
      ayear:'',

    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
   this.selectScoreFile(1);
   this.selectAllOperator()
  },
  methods: {
			//获取所有企业
			selectAllOperator() {
				let that = this;
				this.$axios
					.get('/api/operator/selectAllOperator')
					.then(function(res) {
						if(res.data.code == 200) {
							that.items = res.data.data;
							that.curId = res.data.data[0].operatorNum
						}

					})
			},
    pickerChangeFn(value){ // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
      if(value===null){
        this.ayears = value

      }},
    setabt(){
      if(this.ayears == '' || this.ayears == null){
        this.$message.error('请选择年份！！！');
        return false;
      }
      if(this.aquarter == ''){
        this.$message.error('请选择季度！！！');
        return false;
      }
      this.selectScoreFile(this.curId);
    },

    selectScoreFile(indexs,page){
      let that = this;
      that.curId = indexs;
      that.selectScoreFilepage = page?page:that.selectScoreFilepage
      that.currentPage = page?page:that.selectScoreFilepage
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      let mon = myDate.getMonth() + 1; //获取当前月
      let aquarters = 1
      if(mon>=1&&mon<4){
        aquarters = 1;
      }else if(mon>=4&&mon<7){
        aquarters = 2;
      }else if(mon>=7&&mon<10){
        aquarters = 3;
      }else if(mon>=10&&mon<12){
        aquarters = 4;
      }
      that.ayear =that.ayears||''+years;
      that.aquarte = that.aquarter || aquarters;
      let selectScoreFiledata ={
        page:that.selectScoreFilepage,
        pageSize:that.selectScoreFilepageSize,
        operatorNum:indexs ,
        year:that.ayear,
        quarter:that.aquarte
      }
      that.$axios.defaults.withCredentials=true;
      that.$axios
        .post('/api/scoreItemFile/selectScoreFile',selectScoreFiledata)
        .then(function (res) {
         // console.log(res.data.data.total);
          that.selectScoreFiletotal = res.data.data.total;
          that.selectScoreFilelist = res.data.data.list;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setselectScoreFile(selectScoreFilepage){
      this.selectScoreFilepage = selectScoreFilepage;
      this.selectScoreFile(this.curId);
    },



  },
  watch: {

  },
}
</script>

<style scoped>
 .point{
  display: flex;
  line-height:0px;
   flex-direction: row;/*这里可以不写，flex布局默认方向横向即row*/

   align-items: center;

}
 .el-button--primary{margin-bottom: 0px}
 .el-date-editor{width: 150px}
 /deep/ .el-button--info{
   color: #fff;
   background-color: #409eff;
   border-color: #409eff;
 }

	.lu_head {
		float: left;
		overflow: hidden;
		width: calc(100% - 120px);
	}
	
	.lu_list {
		font-size: 24px;
		padding: 10px 0;
		line-height: 26px;
		border-radius: 5px;
		margin: 5px 0 5px 20px;
		max-width: 116px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		float: left;
		color: #909399;
		cursor: pointer;
	}
	
	.lu_list img {
		width: 24px;
		height: 24px;
		margin-right: 10px;
		position: relative;
		top: 2px;
		filter: grayscale(90%);
	}
	
	.lu_list:hover {
		color: #333;
	}
	
	.lu_list:hover img {
		filter: grayscale(0%);
	}
	
	.lu_active {
		color: #333 !important;
	}
	
	.lu_active img {
		filter: grayscale(0%) !important;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/admin/Scorefile.vue